import React from 'react';
import { withRouter } from 'react-router';
import Heading from '../heading';
import EditTakeover from './edit-takeover';
import './mydistricts.scss';

const InactiveDistricts = props => {
    
    if (!props.districts) return null;
    if (props.districts.length === 0) return null;

    const total = (key) => {
        if (!props.districts) return null;

        return props.districts.reduce((a, b) => a + b[key], 0);
    }

    return (
        <div className="districts__content">
            <Heading heading="Inaktiva säljdistrikt"></Heading>
            <div className="districts__content-fit districts__content-fit--no-padding">
                <div className="districts__table-scroll-fade">
                    <div className="districts__table-scroll">
                        {props.districts &&
                            <table className="table table--num table--border-top table--border-bottom">
                                <thead>
                                    <tr>
                                        <th className="table__text">SÄLJDISTRIKT</th>
                                        <th>Enheter</th>
                                        <th>Area <span className="table__light-header">(km2)</span></th>
                                        {props.type !== 'foodservice' &&
                                            <>
                                                <th>Omsättning <span className="table__light-header">(KKR)</span></th>
                                                <th>Frekvens</th>
                                                <th>Besökstid <span className="table__light-header">(H)</span></th>
                                            </>
                                        }
                                        <th className="table__text">UPPDATERAD</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.districts && props.districts.map(district => {
                                        return (
                                            <tr key={`inactive${district.id}`}>
                                                <td className="table__text">
                                                    <a href={`${props.type === 'foodservice' ? `/foodservice-scenario` : `/scenario`}/${district.salesDistrictScenarioId}/district/${district.id}`}>{district.name}</a>
                                                </td>
                                                <td>{district.numberOfHits}</td>
                                                <td>{district.salesArea.toLocaleString('sv')}</td>
                                                {props.type !== 'foodservice' &&
                                                    <>
                                                        <td>{district.turnOver.toLocaleString('sv')}</td>
                                                        <td>{district.frequency.toLocaleString('sv')}</td>
                                                        <td>{district.vistingTimeHours.toLocaleString('sv')}</td>
                                                    </>
                                                }
                                                <td className="table__text">{new Date(district.lastUpdated).toLocaleDateString('sv')}</td>
                                                <td>
                                                    <EditTakeover id={district.id} 
                                                                    isActive={district.isActive} 
                                                                    createUrl={props.type === 'foodservice' ? '/foodservice-districts/create/' : '/districts/create/'}
                                                                    listUrl={props.type === 'foodservice' ? '/foodservice-scenario' : '/scenario'} 
                                                                    isDistrictEdit={true} 
                                                                    confirmText="Vill du ta bort distriktet permanent?" 
                                                                    editButton="Ändra säljdistriktet" 
                                                                    deleteHeading="TA BORT DISTRIKT" 
                                                                    deleteButtonText="Ta bort distrikt" 
                                                                    scenarioId={district.salesDistrictScenarioId} 
                                                                    districtName={district.name} />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    
                                    <tr className="tfoot">
                                        <td className="table__text">Totalt</td>
                                        <td>{total('numberOfHits').toLocaleString('sv')}</td>
                                        <td>{total('salesArea').toLocaleString('sv')}</td>
                                        {props.type !== 'foodservice' &&
                                            <td>{total('turnOver').toLocaleString('sv')}</td>
                                        }
                                        <td colSpan={props.type === 'foodservice' ? 2 : 5}></td>
                                    </tr>
                                </tbody>
                            </table>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(InactiveDistricts);